module.exports = __webpack_public_path__ + "static/media/dramaImg.4cf53ef1.png";